import { Divider, Modal } from 'antd';
import { Conditional } from 'components/conditional/conditional';
import { useAcceptVoorwaarden, useGetVoorwaarden } from 'components/headers/models/queries';
import { Spinal } from 'components/spinal/Spinal';
import { useEffect, useState } from 'react';

export const useVoorwaardenModal = (enabled = true) => {
  const [visible, setVisible] = useState(false);
  const { data: voorwaarden } = useGetVoorwaarden(enabled);
  const accepteer = useAcceptVoorwaarden();

  useEffect(() => {
    if ((voorwaarden?.length ?? 0) > 0) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [enabled, voorwaarden]);

  if (voorwaarden?.length === 0 && visible) setVisible(false);
  const component = (
    <Modal
      title="Voorwaarden"
      open={visible}
      onOk={() => {
        voorwaarden?.forEach(term => {
          accepteer.mutate(term.termsConditionsId);
        });
      }}
      okText="Accepteer voorwaarden"
      maskClosable={false}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{
        type: 'primary',
        disabled: accepteer.isPending,
      }}
      width={750}
      closable={false}>
      <Spinal loading={accepteer.isPending} initializing={false}>
        {voorwaarden && voorwaarden.map(v => (
          <>
            <p dangerouslySetInnerHTML={{ __html: v.termsConditionsText }}></p>
            <Conditional condition={voorwaarden.length > 1}>
              <Divider />
            </Conditional>
          </>
        ))}
      </Spinal>
    </Modal>
  );

  return { voorwaardenModal: component, isPending: accepteer.isPending };
};
